<template>
    <div class="pt-3 pb-5">
        <data-table ref="requests"
                    :api-route="backendApiRoute"
                    :api-view-set="requestsDataTable.apiViewSet"
                    :name="requestsDataTable.name"
                    :columns="requestsDataTable.columns"
                    :search="requestsDataTable.search"
                    :search-placeholder="requestsDataTable.searchPlaceholder"
                    :filters="requestsDataTable.filters ? requestsDataTable.filters : []"
                    :actions="requestsDataTable.actions"
                    :orderings="requestsDataTable.orderings"
                    :initial-orderings="requestsDataTable.initialOrderings"
                    :row-actions="requestsDataTable.rowActions"
                    :key="requestsDataTable.key"
                    :destroy-title="'Удаление заявки'"
                    :context-menu-wrapper-id="''"
                    :show-select-row-column="canWorkWithArchive()"
                    @filter-reset="onFilterReset">
            <template #extraActionControl>
                <b-collapse id="archive-control" v-model="archiveControlsVisible" v-if="canWorkWithArchive()">
                    <div class="d-flex flex-wrap mb-3 bg-light rounded p-2 p-md-3 pb-3 pb-md-4">
                        <div class="d-flex flex-column flex-grow-1">
                            <div class="d-flex flex-column">
                                <div class="d-flex flex-column">
                                    <small class="flex-grow-0 mr-2 text-secondary">Отображение архивированных записей</small>
                                    <div class="d-flex align-items-center flex-wrap flex-grow-0 p-2">
                                        <b-form-radio @change="onArchiveControlTypeChanged" v-model="archiveControlType" name="archive-control-types" value="0" class="mr-4 mb-2">Все</b-form-radio>
                                        <b-form-radio @change="onArchiveControlTypeChanged" v-model="archiveControlType" name="archive-control-types" value="3" class="mr-4 mb-2">Актуальные</b-form-radio>
                                        <b-form-radio @change="onArchiveControlTypeChanged" v-model="archiveControlType" name="archive-control-types" value="1" class="mr-4 mb-2">К архивированию (созданы более 3 лет назад) </b-form-radio>
                                        <b-form-radio @change="onArchiveControlTypeChanged" v-model="archiveControlType" name="archive-control-types" value="2" class="mr-4 mb-2">К удалению (перемещены в архив)</b-form-radio>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-lg-10 col-xl-6 col-xxl-4 p-0 m-0" v-if="parseInt(archiveControlType) === 2">
                                    <data-table-date-from-to-filter ref="archiveDate"
                                                                    :filter="getArchiveDateFilter()"
                                                                    :initial-value-from="getInitialArchiveDateFromFilter()"
                                                                    :initial-value-to="getInitialArchiveDateToFilter()"
                                                                    v-on:filter-added="onArchiveDateFilterAdded"
                                                                    v-on:filter-removed="onArchiveDateFilterRemoved" />
                                </div>
                            </div>
                            <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center mt-3" v-if="getSelectedRowIds().length">
                                <span class="mr-2 mb-2">{{ getSelectedLabel() }}</span>
                                <b-button v-if="parseInt(archiveControlType) === 1" variant="info" class="mr-2 mb-2"  @click="onMoveToArchiveClick">Переместить в архив</b-button>
                                <b-button v-if="parseInt(archiveControlType) === 2" variant="primary" class="mr-2 mb-2" @click="onReturnFromArchiveClick">Вернуть из архива</b-button>
                                <b-button v-if="parseInt(archiveControlType) === 2" variant="danger" v-b-modal="'delete-irreversibly'" class="mb-2" @click="showIrreversibleDeleteModal">Удалить безвозвратно</b-button>
                            </div>
                        </div>
                    </div>

                </b-collapse>
            </template>
        </data-table>

        <data-table-irreversible-delete-modal ref="deleteIrreversibly" :url="getIrreversibleDeleteUrl()" @irreversible-delete-success="onIrreversibleDeleteSuccess">
            <template #genitiveObjectName>{{ getRequestGenitive() }}</template>
            <template #linkedObjectsText><span>Также будут удалены связанные <strong>рейды</strong>.</span></template>
        </data-table-irreversible-delete-modal>

    </div>
</template>

<script>
    import DataTable from "../../../components/Table/DataTable";
    import DataTableDateFromToFilter from "@/components/Table/DataTableDateFromToFilter.vue";
    import actions, {Action, AvailableAction} from "../../../components/Table/actions";
    import api from "../../../api";
    import { mapGetters } from 'vuex';
    import { Request } from "./request";
    import DownloadButton from "../../../components/Files/DownloadButton";
    import {download} from "@/components/Files/download";
    import {ACTIVITIES} from "@/store/auth/auth";
    import EventBus from "@/bus";
    import httpClient from "@/http";
    import DataTableIrreversibleDeleteModal from "@/components/Table/DataTableIrreversibleDeleteModal.vue";
    import {ArchiveMixin} from "@/pages/Common/archiveMixin";

    export default {
        name: "RequestsList",
        components: {
            DataTableIrreversibleDeleteModal,
            DataTable,
            DownloadButton, DataTableDateFromToFilter
        },
        mixins: [ ArchiveMixin ],
        computed: {
            ...mapGetters(['ability', 'isInController', 'isInContractor', 'isMunicipalController', 'userOrganizationActivities',
                'userOrganizationMunicipalities', 'hasMunicipalityRestrictions', 'getFilters']),
            backendApiRoute() { return api.requests.default.list() },
            initialFiltersForActivityFilter() {
                let filters = [];
                if (this.isInContractor) {
                    for (const a of this.userOrganizationActivities) {
                        filters.push({'key': 'activity', 'value': a})
                    }
                    if (this.userOrganizationActivities.includes(ACTIVITIES.KEEPING)) {
                        filters.push({'key': 'activity', 'value': ACTIVITIES.CATCHING})
                    }
                }
                return filters
            },

            // TODO: Используется в CommonEventList, переиспользовать в миксине
            initialFiltersForMunicipalityFilter() {
                let filters = [];
                if (this.hasMunicipalityRestrictions) {
                    for (const m of this.userOrganizationMunicipalities) {
                        filters.push({'key': 'municipality', 'value': m})
                    }
                }
                return filters
            }
        },
        data() {
            return {
                selectedForDestroy: null,
                requestsDataTable: {
                    name: 'requests-table',
                    apiViewSet: api.requests.default,
                    key: 'requests-table',
                    search: true,
                    searchPlaceholder: 'Поиск по номеру заявки, контракта, по адресу',
                    columns: [
                        {
                            name: 'number',
                            title:  'Заявка',
                            alwaysVisible: true,
                            to: {
                                idColumn: 'id',
                                routeName: 'requestsDetail',
                                prependWithN: true
                            },
                            extraDataFrom: 'created_at'
                        },
                        { name: 'description_object.activity_name', 'title': 'Тип'},
                        { name: 'description_object', 'title': 'Статус',
                            cellComponentName: 'RequestStatusCell',
                            cellComponentPath: 'src/pages/DataTableCells/',
                            extraDataFrom: 'progress'},
                        { name: 'is_from_navigator', 'title': 'С сайта',
                            cellComponentName: 'BooleanCell',
                            cellComponentPath: 'src/pages/DataTableCells/'},
                        { name: 'animal_species_name', 'title': 'Животное'},
                        { name: 'address_object.municipality_name', 'title': 'Муниципалитет'},
                        { name: 'address_object.short_text', 'title': 'Адрес', width: '300px'},
                        { name: 'result', 'title': 'Результат'},
                        { name: 'applicant', 'title': 'Заявитель', extraDataFrom: 'applicant_phone'},
                        { name: 'contract_object.contractor_object.name', 'title': 'Исполнитель', extraDataFrom: 'contract_object.number'},
                        { name: 'last_raid_date', 'title': 'Последний рейд', cellComponentName: 'DateTimeCell',
                            cellComponentPath: 'src/pages/DataTableCells/', extraDataFrom: 'last_raid_comment'},
                    ],
                    orderings: [
                        'number',
                        {'status_object': 'status'},
                        {'activity_name': 'activity'},
                        {'address_object.municipality_name': 'address__municipality'},
                        {'contract_object.contractor_object.name': 'contract__contractor__name'},
                        'animals_count',
                        'caught_count',
                        'archive_date'
                    ],
                    actions: [
                    ],
                    rowActions: [
                    ],
                    filters: [
                        { title: 'Вид животного', name: 'animal_species', source: api.species.default.list()},
                        { title: 'Статус', name: 'status', source: api.requests.status.list(api.requests.default.list())},
                        { title: 'Создана', name: 'created_at', type: 'dateFromTo' },
                        { title: 'Дата рейда', name: 'actual_date', type: 'dateFromTo' },
                    ],
                    initialOrderings: {
                        'number': 2
                    }
                }
            }
        },
        methods: {
            getTableRef() {
                return this.$refs.requests
            },
            getArchiveUrl() {
                return api.requests.archive.list()
            },
            getExtractUrl() {
                return api.requests.extract.list()
            },
            getDeleteUrl() {
                return api.requests.deleteIrreversibly.list()
            },
            getRequestGenitive() {
                const len = this.getSelectedRowIds().length;
                const rem = len % 10;
                if (rem === 1 && (len < 10 || len > 20)) {
                    return 'заявку'
                }
                else if (rem > 1 && rem < 5  && (len < 10 || len > 20)) {
                    return 'заявки'
                } else {
                    return 'заявок'
                }
            },
            getInitialArchiveDateFromFilter() {
                const storedFilters = this.getFilters(this.requestsDataTable.name);
                for (const filter of storedFilters) {
                    if (filter['key'] === 'archive_date_from') {
                        return filter
                    }
                }
                return null;
            },

            getInitialArchiveDateToFilter() {
                const storedFilters = this.getFilters(this.requestsDataTable.name);
                for (const filter of storedFilters) {
                    if (filter['key'] === 'archive_date_to') {
                        return filter
                    }
                }
                return null;
            },
        },
        beforeMount() {
            if (this.canWorkWithArchive()) {
                const storedFilters = this.getFilters(this.requestsDataTable.name);
                let storedArchiveControlType = null;
                for (const storedFilter of storedFilters) {
                    if (storedFilter['key'] === 'needs_archive') {
                        storedArchiveControlType = '1'
                    }
                    if (storedFilter['key'] === 'is_archived') {
                        storedArchiveControlType = '2'
                    }
                    if (storedFilter['key'] === 'is_actual') {
                        storedArchiveControlType = '3'
                    }
                    if (storedArchiveControlType !== null) {
                        this.archiveControlType = storedArchiveControlType;
                        this.archiveControlsVisible = true
                        break
                    }
                }
            }
        },
        mounted() {
            const vm = this;

            if (vm.isInContractor) {
                vm.requestsDataTable.filters.push({ title: 'Заказчик',
                    name: 'customer',
                    source: `${api.requests.customers.list()}`,
                    hasSearch: true
                })
            }

            if (vm.isInController) {
                vm.requestsDataTable.filters.push({ title: 'Исполнитель',
                    name: 'contractor',
                    source: `${api.requests.contractors.list()}`,
                    hasSearch: true
                })
            }

            if (vm.ability.can('create', 'Request')) {
                vm.requestsDataTable.actions.push(
                    actions.create(() => {
                            vm.$router.push({name: 'requestCreate'})
                        }, vm.ability.can('create', 'Request')
                    )
                );
            }

            if (vm.initialFiltersForMunicipalityFilter.length !== 1) {
                vm.requestsDataTable.filters.unshift({
                    title: 'Муниципалитет',
                    name: 'municipality',
                    source: api.municipalities.default.list(),
                    labelKey: 'short_name',
                    hasSearch: true,
                    initialFilters: vm.initialFiltersForMunicipalityFilter
                })
            }

            if (vm.initialFiltersForActivityFilter.length !== 1) {
                vm.requestsDataTable.filters.unshift({
                    title: 'Тип',
                    name: 'activity',
                    source: api.requests.activities.list(),
                    initialFilters: vm.initialFiltersForActivityFilter
                })
            }

            // ,

            vm.requestsDataTable.actions.push(
                actions.downloadXlsx((e, emittedEventNameStart, emittedEventNameFinish) => {
                        const downloadBaseUrl = api.requests.xlsx.list();
                        const downloadUrl = downloadBaseUrl + vm.$refs.requests.getQueryString();
                        EventBus.$emit(emittedEventNameStart)
                        download(downloadUrl).then((response) => {
                            vm.$bvToast.toast('Выгрузка завершена', {title: 'Выгрузка документа', autoHideDelay: 5000, variant: 'success'})
                        })
                        .catch(() => {
                            vm.$bvToast.toast('Не удалось произвести выгрузку', {title: 'Выгрузка документа', autoHideDelay: 5000, variant: 'danger'})
                        })
                        .finally(() => {
                            EventBus.$emit(emittedEventNameFinish)
                        })
                    }, true, 'Выгрузить журнал заявок')
                );

            if (vm.canWorkWithArchive()) {
                vm.requestsDataTable.actions.push(
                    new Action({
                        name: 'archive',
                        icon: 'archive',
                        variant: 'danger',
                        title: 'Архив',
                        showTitle: false,
                        emittedEvent: 'on-show-archive-controls',
                        handler: 'onShowArchiveControls',
                        available: true
                    }, (e, emittedEventNameStart, emittedEventNameFinish) => { vm.archiveControlsVisible = !vm.archiveControlsVisible })
                );

                vm.requestsDataTable.columns.push({
                    name: 'archive_date',
                    'title': 'Дата перемещения в архив'}
                )
            }

            if (vm.ability.can('destroy', 'Request')) {
                vm.requestsDataTable.rowActions.push(
                    new actions.objectDelete(Request))
            }
        }
    }
</script>

<style scoped>

</style>